import { createSelector } from "reselect"
import { forEach, concat, reduce } from "lodash"
import { computeDriftValues } from "helpers/drift"
import { getRiskHistory } from "./risk"

export const getDrift = createSelector(
  [getRiskHistory],
  (risk) => {
    const riskValuesByFactor = {}
    forEach(risk, ({ factors }) => {
      forEach(factors, (value, factorId) => {
        riskValuesByFactor[factorId] = riskValuesByFactor[factorId] ? concat(riskValuesByFactor[factorId], value) : [value]
      })
    })

    return reduce(riskValuesByFactor, (driftValues, values, factorId) => {
      driftValues[factorId] = computeDriftValues(values)
      return driftValues
    }, {})
  },
)
